import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Nace } from 'src/app/models/excel/nace';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';

@Component({
  selector: 'app-select-nace-search',
  templateUrl: './select-nace-search.component.html',
  styleUrl: './select-nace-search.component.scss',
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    FormsModule,
    ReactiveFormsModule,
    MatOption,
    MatSelectSearchComponent,
    MatError,
  ],
})
export class SelectNaceSearchComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() naceMapControlName: string;
  @Input() actExcelInput: any; // Replace 'any' with the appropriate type
  @Input() filteredNaceMaps: { key: string; value: Nace }[] = [];
  @Output() filteredNaceMapsChange = new EventEmitter<
    { key: string; value: Nace }[]
  >();

  ngOnInit() {
    this.formGroup
      .get(this.naceMapControlName)
      .valueChanges.subscribe((value) => {
        if (this.actExcelInput?.nace?.naceMap) {
          const naceArray: { key: string; value: Nace }[] = Object.entries(
            this.actExcelInput.nace.naceMap
          ).map(([key, value]) => ({ key, value }));

          const filteredNaceMaps = naceArray
            .filter((naceMap) =>
              naceMap.key.toLowerCase().includes(value.toLowerCase())
            )
            .sort(
              (a, b) =>
                a.key.toLowerCase().indexOf(value.toLowerCase()) -
                b.key.toLowerCase().indexOf(value.toLowerCase())
            );

          this.filteredNaceMapsChange.emit(filteredNaceMaps);
        }
      });
  }
}
